import { render } from "./NcrmPrivacyNoticesSection.vue?vue&type=template&id=24bbf9b5&scoped=true"
import script from "./NcrmPrivacyNoticesSection.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyNoticesSection.vue?vue&type=script&lang=js"

import "./NcrmPrivacyNoticesSection.vue?vue&type=style&index=0&id=24bbf9b5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bbf9b5"]])

export default __exports__